import React from 'react';
import type { Text as RNText } from 'react-native';
import { BodyText } from '../BodyText';
import { highlightWords } from './HighlightWords.helpers';

export const HighlightWords = React.forwardRef(
  (props: HighlightWordsProps, ref: React.Ref<RNText> | undefined) => {
    const { text, highlights = [], ...restProps } = props;
    const substrings = highlightWords(text, highlights);

    /* -- prevent nested components usage if there is only one substring ---- */

    if (substrings.length === 1) {
      const [{ substring, shouldHighlight }] = substrings;

      return (
        <BodyText bold={shouldHighlight} {...restProps}>
          {substring}
        </BodyText>
      );
    }

    /* -- use nested components if there are more than one substrings ------- */

    return (
      <BodyText ref={ref} {...restProps}>
        {substrings.map(({ key, substring, shouldHighlight }) => {
          return (
            <BodyText key={key} bold={shouldHighlight} {...restProps}>
              {substring}
            </BodyText>
          );
        })}
      </BodyText>
    );
  },
);

/* -- types ----------------------------------------------------------------- */

type HighlightWordsProps = {
  /** Text to highlight */
  readonly text: string;

  /** Highlight groups */
  readonly highlights?: readonly string[];
} & Omit<React.ComponentProps<typeof BodyText>, 'children' | 'bold'>;
